import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import ScriptsTable from "@/components/scripts/scripts-table";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";

// Vive en `scripts/index.tsx` (no en `scripts.tsx`): con `scripts.tsx` la
// lista era la ruta PADRE de `scripts/$scriptId` y, al no renderizar
// `<Outlet />`, "Nuevo script" y los links a cada script cambiaban la URL
// pero seguian mostrando la lista.
const scriptsSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  state: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/settings/_layout/scripts/")({
  validateSearch: scriptsSearchSchema,
  component: ScriptsPage,
});

function ScriptsPage() {
  const searchParams = Route.useSearch();

  return (
    <RouteGuardPermissions
      permissions={[{ module: "custom_fields", actions: ["read", "update"] }]}
    >
      <ScriptsTable
        currentPage={searchParams.page}
        pageSize={20}
        basePath="/settings/scripts"
        searchParams={searchParams}
      />
    </RouteGuardPermissions>
  );
}
